<template>
    <div class="login">
        <van-nav-bar title="注册" left-arrow @click-left="back"></van-nav-bar>
        <header class="header">
            <Banner />
        </header>
        <main class="main">
            <van-form class="form" ref="formRef" v-if="isTel">
                <div class="form-item">
                    <van-field type="number" :required="true" v-model="form.tel" :rules="[
              {
                validator: ValidatorPhone,
                message: '手机号码错误',
              },
            ]" placeholder="手机号码" />
                </div>
                <div class="form-item">
                    <van-field :required="true" v-model="form.captcha" placeholder="图形验证码">
                        <template #button>
                            <div class="login-code">
                                <img :src="codeUrl" @click="getCode" class="login-code-img" />
                            </div>
                        </template>
                    </van-field>
                </div>

                <div class="form-item">
                    <van-field type="number" :required="true" :maxlength="4" v-model="form.code" placeholder="验证码">
                        <template #button>
                            <van-button color="#999" size="small" v-if="isSend">{{ count }}s</van-button>
                            <van-button :style="primaryBg" size="small" v-else @click="sendCode()">发送验证码</van-button>
                        </template>
                    </van-field>
                </div>
                <div class="button" :style="primaryBg" @click="onSubmit">提交</div>

            </van-form>
            <van-form class="form" ref="formRef" v-else>
                <div class="form-item">
                    <van-field :required="true" :rules="[
              {
                validator: validateEmail,
                message: '邮箱错误',
              },
            ]" v-model="form.email" placeholder="邮箱" />
                </div>
                <div class="form-item">
                    <van-field :required="true" type="number" v-model="form.code" placeholder="验证码">
                        <template #button>
                            <van-button color="#999" size="small" v-if="isSend">{{ count }}s</van-button>
                            <van-button :style="primaryBg" size="small" v-else @click="sendEmailCode()">发送验证码</van-button>
                        </template>
                    </van-field>
                </div>
                <div class="button" :style="primaryBg" @click="onSubmit">提交</div>

            </van-form>
            <div class="change-type" v-if="isEmailReg">
                <!-- <div class="divider">
                    <span>or</span>
                </div> -->

                <div class="change-btn" v-if="isTel" @click="hanldeChangeRegType('email',false)">

                    <p>港澳台观众登记</p>

                </div>
                <div class="change-btn" v-else @click="hanldeChangeRegType('tel',true)">

                    <p>中国大陆观众登记</p>

                </div>
            </div>
        </main>

    </div>
</template>

<script>
import { getUrlCode } from '@/utils';
import Toast from 'vant/lib/toast';
import { mapGetters } from 'vuex';
import httpRequest from '@/module_visitor/api/http.js';
import { isPhone } from '@/utils/filters.js';
import Banner from '@/components/Common/banner';
export default {
    data() {
        return {
            timer: null,
            count: 60,
            isSend: false,
            form: {
                code: '',
                tel: '',
                email: '',
                type: 'tel',
                captcha: '',
            },
            isTel: true,
            codeUrl: '',
            uuid: '',
        };
    },
    components: { Banner },
    computed: {
        ...mapGetters(['defaultInfo']),

        isEmailReg() {
            const { config } = this.defaultInfo;
            var othersJson = JSON.parse(config.others);
            if (othersJson) {
                return othersJson.isEmailReg == 1;
            }
            return false;
        },
        primaryBg() {
            return { background: this.defaultInfo.config.primaryColor };
        },
        primaryColor() {
            return { color: this.defaultInfo.config.primaryColor };
        },
    },
    created() {
        this.getCode();
    },

    methods: {
        back() {
            this.$router.go(-1);
        },
        getCode() {
            httpRequest.get(`/common/CaptchaImage`).then(res => {
                const { code, data } = res.data;
                if (code == 200) {
                    this.uuid = data.uuid;
                    this.codeUrl = 'data:image/gif;base64,' + data.img;
                }
            });
        },
        // 验证手机
        ValidatorPhone(val) {
            return /^1(3|4|5|6|7|8|9)[0-9]{9}$/.test(val);
        },
        validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        hanldeChangeRegType(type, isTel) {
            this.form.type = type;
            this.isTel = isTel;
        },
        // 验证码
        Countdown() {
            this.isSend = true;
            this.timer = setInterval(() => {
                this.count--;
                if (this.count == 0) {
                    this.timer == null;
                    this.count = 60;
                    clearInterval(this.timer);
                    this.isSend = false;
                }
            }, 1000);
        },

        // 发送验证码
        sendCode() {
            if (this.form.tel == '' || !isPhone(this.form.tel)) {
                Toast('请输入正确的手机号码！');
                return;
            }

            let params = {
                tel: this.form.tel,
                code: this.form.captcha,
                uuid: this.uuid,
            };
            httpRequest.post(`/api/visitor/sendCode`, params).then(res => {
                const { data, code, msg } = res.data;
                if (code == 200) {
                    Toast.success('发送成功');
                    this.Countdown();
                } else if (code == 103) {
                    this.getCode();
                    Toast.fail(msg);
                } else {
                    Toast.fail(msg);
                }
            });
        },
        sendEmailCode() {
            var acid = getUrlCode();
            let params = {
                email: this.form.email,
                acid: acid,
            };
            httpRequest.post(`/api/visitor/sendEmailCode`, params).then(res => {
                const { data, code, msg } = res.data;
                if (code == 200) {
                    Toast.success('发送成功');
                    this.Countdown();
                } else {
                    Toast.fail('验证码有误');
                }
            });
        },
        // 验证用户
        handleLogin() {
            if (this.code == '') {
                Toast('请填写验证码！');
                return;
            }
            let params = {
                Tel: this.form.tel,
                Email: this.form.email,
                Code: this.form.code,
                LoginType: this.form.type,
            };
            this.$refs.formRef.validate().then(() => {
                httpRequest
                    .post(`/api/visitor/verifyCode`, params)
                    .then(res => {
                        const { data, code, msg } = res.data;
                        if (code == 200) {
                            localStorage.setItem('v_token', data.token);
                            this.$router.push({ path: '/' });
                        } else if (code == 104) {
                            if (this.form.type == 'email') {
                                this.$router.push({
                                    path: '/registerEmail',
                                    query: {
                                        source: this.$route.query.source,
                                        companyId: this.$route.query.companyId,
                                        companyShareId: this.$route.query.companyShareId,
                                        teamId: this.$route.query.teamId,
                                        tel: this.form.tel,
                                        email: this.form.email,
                                    },
                                });
                            } else {
                                this.$router.push({
                                    path: '/register',
                                    query: {
                                        source: this.$route.query.source,
                                        companyId: this.$route.query.companyId,
                                        companyShareId: this.$route.query.companyShareId,
                                        teamId: this.$route.query.teamId,
                                        tel: this.form.tel,
                                        email: this.form.email,
                                    },
                                });
                            }
                        } else {
                            Toast(msg);
                        }
                    })
                    .catch(error => {});
            });
        },

        //登录
        onSubmit() {
            this.handleLogin();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.login {
    width: 100%;
    min-height: 100vh;
    background: #fff;
    .header {
    }

    .banner {
        width: 100%;
        text-align: center;
        img {
            width: 100%;
        }
    }

    .main {
        width: 100%;
        .van-button {
            background: var(--theme_bg_color);
            color: #fff;
        }
        .form {
            .form-item {
            }
            .button {
            }
        }
        .change-type {
            margin: 40px 10px;
            .divider {
                height: 1px;
                width: 100%;

                box-sizing: border-box;
                position: relative;
                background: #eaeaea;
                span {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    display: block;
                    text-align: center;
                    width: 60px;
                    height: 30px;
                    line-height: 30px;
                    background: #fff;
                    color: #999;
                    z-index: 9;
                }
            }
            .change-btn {
                display: block;
                color: #171ad3;
                text-align: right;
                margin-top: 12px;
                height: 40px;
                line-height: 40px;

                margin: 40px 10px;
                border-radius: 4px;
            }
        }
        .form {
            margin: 10px;
            border-radius: 10px;
            padding: 8px 10px;

            .form-item {
                display: flex;
                align-items: center;

                font-size: 18px;
                border: 1px solid #f8f8f8;
                background: #eee;
                margin-top: 20px;

                .form-icon {
                    padding: 0 8px;

                    img {
                        width: 24px;
                        height: 36px;
                    }
                }
            }
            .form-item {
            }

            .button {
                background: var(--theme_bg_color);
                color: #fff;
                line-height: 40px;
                text-align: center;
                height: 40px;
                margin: 20px auto 0;
                width: 100%;
                border-radius: 5px;
            }
        }
    }
}
</style>